import React from 'react';
export const skinToTypographyMap = {
    default: 'secondary',
    error: 'error',
    success: 'success',
    warning: 'warning',
    primary: 'primary'
};
export const sizeToTypographyVariantMap = {
    default: 'paragraph2',
    big: 'paragraph2',
    small: 'paragraph3'
};
